import React, { useMemo } from "react";
import { Breadcrumb } from "antd";
import { Link, useLocation, useMatches } from "react-router-dom";
import { useStudent } from "./StudentContext";

const StudentBreadcrumbs = () => {
	const location = useLocation();
	const matches = useMatches();
	const state = location.state || {};
	const { navigationChapter } = useStudent();
	const currentRoute = matches[matches.length - 1];
	const pageLabel =  location.pathname === "/marked-incorrect-instructions" ? state?.breadcrumbLabel : currentRoute?.handle?.breadcrumb;
	const stateParentRoute = state?.parentBreadcrumb;
	const breadcrumbTrail = Array.isArray(state?.breadcrumbTrail) ? state.breadcrumbTrail : [];
	const parentRoute = stateParentRoute || currentRoute?.handle?.parentBreadcrumb;
	const chapterId = navigationChapter?.chapterId;
	const chapterName = navigationChapter?.chapterName;
	const linkClass = "!text-[#064ae3] font-medium hover:text-[#0036b3] hover:underline focus:text-[#0036b3] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2";
	const items = useMemo(() => {
		if (!pageLabel || location.pathname === "/dashboard") return [];

		const breadcrumbState = {
			...state,
			...(chapterId
				? {
					chapter_id: chapterId,
					chapter_name: chapterName,
				}
				: {}),
		};

		const crumbs = [
			{
				title: (
					<Link className={linkClass} to="/dashboard">
						Dashboard
					</Link>
				),
			},
		];

		if (breadcrumbTrail.length > 0) {
			breadcrumbTrail.forEach((crumb) => {
				crumbs.push({
					title: (
						<Link
							className={linkClass}
							to={crumb.path}
							state={crumb.state || {}}
						>
							{crumb.label}
						</Link>
					),
				});
			});
		} else if (location.pathname !== "/chapter-resources" && chapterId && !stateParentRoute) {
			crumbs.push({
				title: (
					<Link
						className={linkClass}
						to="/chapter-resources"
						state={breadcrumbState}
					>
						{`Chapter ${chapterId}`}
					</Link>
				),
			});
		}

		if (breadcrumbTrail.length === 0 && parentRoute) {
			const parentState = typeof parentRoute.state === "function"
				? parentRoute.state(breadcrumbState)
				: stateParentRoute
					? (stateParentRoute.state || {})
					: breadcrumbState;

			crumbs.push({
				title: (
					<Link
						className={linkClass}
						to={parentRoute.path}
						state={parentState}
					>
						{parentRoute.label}
					</Link>
				),
			});
		}

		crumbs.push({
			title: (
				<span aria-current="page" className="text-gray-900 font-medium">{pageLabel}</span>
			),
		});

		return crumbs;
	}, [breadcrumbTrail, chapterId, chapterName, pageLabel, parentRoute, stateParentRoute, location.pathname, state]);

	if (items.length === 0) return null;

	return (
		<div className="mb-2">
			<Breadcrumb
				aria-label="Breadcrumb"
				className="student-breadcrumbs inline-flex items-center max-w-full px-2 py-1 bg-gray-200 rounded text-base leading-[1.4] mr-12 sm:mr-0 "
				items={items}
			/>
		</div>
	);
};

export default StudentBreadcrumbs;

